module.exports = __webpack_public_path__ + "img/107.8352f81d.svg";